import React, {useEffect, useRef, useState} from "react";
import {
  exibirMensagemErro,
  exibirMensagemSucesso,
  formatarDinheiroItl,
  HttpVerbo,
  xfetch
} from "../../util";
import {useNavigate, useParams} from "react-router-dom";
import {PaginaLogada} from "../../componentes";
import {downloadArquivo, upload} from "../../util/xfetch";
import {formatarPorcentagem} from "../../util/mascara";
import MetasProjeto from '../../componentes/projeto/metas-projeto';
import Atividade from '../../componentes/atividade';
import CardPadrao from "../../componentes/card/card-padrao";
import {ActionIcon, Anchor, Divider, FileInput, Grid, List, Table, TextInput, Tooltip} from "@mantine/core";
import {BotaoAlterar, BotaoUpload} from "../../componentes/botao/botao-mantine";
import {Projeto} from "../../tipos/projeto";
import {
  COL_RESP_2,
  COL_RESP_4,
  COL_RESP_6,
  COL_RESP_8,
  COR
} from "../../config/constantes/constantes-mantine";
import {dateParser, displayFlagStyle} from "../../util/util";
import {IconPencilDollar} from "@tabler/icons-react";
import {DateInput} from "@mantine/dates";

export default function ProjetoDetalhes() {

  const navegacao = useNavigate()
  const parametros = useParams();
  const [isCarregando, setIsCarregando] = useState(false)
  const [projeto, setProjeto] = useState<Projeto>(new Projeto())
  const [files, setFiles] = useState('')
  const inputUploadRef = useRef<any>()
  const [atividadesTramitacao, setAtividadesTramitacao] = useState([])
  const [atividades, setAtividades] = useState([])

  const onChangeUpload = (e: any) => {
    setFiles(e)
  };

  function carregarProjeto() {
    setIsCarregando(true)
    const id = parametros.id
    xfetch('/projeto/' + id, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(data => {
        setProjeto(data)
        setIsCarregando(false)
      })
      .catch(err => {
        setIsCarregando(false)
        exibirMensagemErro("Erro ao carregar projeto - " + err.messsage)
      })
  }

  function carregarAtividadesTramitacao() {
    setIsCarregando(true)
    xfetch(`/atividade/tramitacao/projeto/${parametros.id}`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setAtividadesTramitacao(dados))
      .finally(() => setIsCarregando(false))
  }

  function carregarAtividades() {
    setIsCarregando(true)
    xfetch(`/atividade/projeto/${parametros.id}`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setAtividades(dados))
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    carregarProjeto()
    carregarAtividadesTramitacao()
    carregarAtividades()
  }, [])

  function uploadFiles() {

    if (files === "") return exibirMensagemErro("Nenhum arquivo foi anexado.")

    let formData = new FormData();

    for (const element of files) {
      formData.append("arquivos", element)
    }

    formData.append('idProjeto', projeto.id.toString())
    setFiles('')
    upload('/projeto/' + projeto.id.toString() + '/upload', formData)
      .then(res => {
        if (res.status === 200) {
          exibirMensagemSucesso('Upload feito com sucesso')
          carregarProjeto()
          inputUploadRef.current.value = ''
        }
      })
      .catch(err => {
        exibirMensagemErro('Erro ao fazer upload - ' + err)
      })
  }

  function baixarAnexo(uuid: string, nome: string) {
    const endpoint = '/projeto/' + projeto.id + '/download/' + uuid;
    downloadArquivo(endpoint, nome)
  }

  function alterarProjeto() {
    setIsCarregando(true)
    const dados = {
      idProjeto: projeto.id,
      dataLimite: projeto.dataLimite
    }
    xfetch('/projeto/alterarDataLimite', dados, HttpVerbo.POST)
      .then(res => res.json())
      .then(dados => {
        setProjeto(dados)
        exibirMensagemSucesso("Data limite alterada")
      })
      .finally(() => setIsCarregando(false))
  }

  let valorTotalCapital = 0
  let valorTotalCusteio = 0

  if (projeto.metas) {
    projeto.metas.forEach((m) => {
      if (m.valorCusteio) {
        valorTotalCusteio += m.valorCusteio
      }
      if (m.valorCapital)
        valorTotalCapital += m.valorCapital
    })
  }

  function abrirConta(id: number) {
    navegacao(`/conta/${id}/atualizacaoMonetaria`)
  }

  const isFundoAFundo = projeto.fonteRecurso === 'FUNDO A FUNDO';

  return (
    <PaginaLogada titulo='Detalhes do projeto' isCarregando={isCarregando} botaoVoltar={true}>
      <CardPadrao my={10}>
        <form>
          <Grid>
            <Grid.Col span={COL_RESP_8}>
              <TextInput
                disabled
                label="Nome do projeto"
                value={projeto.nome}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_4}>
              <TextInput
                disabled
                label={"Fonte de recurso"}
                value={projeto.fonteRecurso}/>
            </Grid.Col>
          </Grid>
          <Grid style={displayFlagStyle(!isFundoAFundo)} grow>
            <Grid.Col span={COL_RESP_2}>
              <TextInput
                disabled
                label="Número IGESP"
                value={projeto.numeroIgesp}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_2}>
              <TextInput
                label={"Valor celebrado"}
                disabled
                aria-label="Valor total"
                value={formatarDinheiroItl(projeto.valorTotal)}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_2}>
              <TextInput
                label="Valor contrapartida"
                disabled
                aria-label="Contrapartida"
                value={formatarDinheiroItl(projeto.valorContrapartida)}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_2}>
              <TextInput
                label="Percentual contrapartida"
                disabled
                aria-label="Contrapartida"
                value={formatarPorcentagem(projeto.pcContrapartida) + "%"}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_2}>
              <TextInput
                label="Convênio"
                disabled
                value={projeto.convenio}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <TextInput
                label="Conta Bancária"
                disabled
                value={projeto.contaBancaria}
              />
            </Grid.Col>
          </Grid>
          <Grid style={{alignSelf: "self-end"}}>
            <Grid.Col span={COL_RESP_2}>
              <TextInput
                disabled
                label={"Ano do Projeto"}
                value={projeto.ano}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_2}>
              <DateInput
                disabled
                valueFormat="DD/MM/YYYY"
                label={"Data Início Execução"}
                value={dateParser(projeto.dataInicio)}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_2}>
              <DateInput
                disabled={!isFundoAFundo}
                valueFormat="DD/MM/YYYY"
                label={"Data Limite Execução"}
                value={dateParser(projeto.dataLimite)}
                onChange={(e) => setProjeto({...projeto, dataLimite: new Date(e!!)})}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_2} style={displayFlagStyle(isFundoAFundo)} className={"alinhar-abaixo"}>
              <BotaoAlterar onClick={alterarProjeto}/>
            </Grid.Col>
          </Grid>
        </form>
      </CardPadrao>

      <MetasProjeto setIsCarregando={setIsCarregando} idProjeto={parametros.id!!} isFundoAFundo={isFundoAFundo}/>

      <CardPadrao titulo={"Contas e Valores"} my={10} style={displayFlagStyle(isFundoAFundo)}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Eixo</Table.Th>
              <Table.Th>Conta Custeio</Table.Th>
              <Table.Th>Conta Capital</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {projeto.metas?.map((m, k) => {
              return (
                <Table.Tr key={k} style={{verticalAlign: "middle"}}>
                  <Table.Td>{m.descricao}</Table.Td>
                  <Table.Td>
                    {m.contaCusteio?.banco + ' | Ag ' + m.contaCusteio?.agencia + ' | CC ' + m.contaCusteio?.conta}
                    <Tooltip label={"Correção Monetária"}>
                      <ActionIcon ml={10} aria-label="Correção Monetária" color={COR.ALERTA}
                                  onClick={() => abrirConta(m.contaCusteio?.id!!)}>
                        <IconPencilDollar/>
                      </ActionIcon>
                    </Tooltip>
                  </Table.Td>
                  <Table.Td>
                    {m.contaCapital?.banco + ' | Ag ' + m.contaCapital?.agencia + ' | CC ' + m.contaCapital?.conta}
                    <Tooltip label={"Correção Monetária"}>
                      <ActionIcon ml={10} aria-label="Correção Monetária" color={COR.ALERTA}
                                  onClick={() => abrirConta(m.contaCapital?.id!!)}>
                        <IconPencilDollar/>
                      </ActionIcon>
                    </Tooltip>
                  </Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
        <Divider mt={30} mb={20} size={"sm"}/>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Total Custeio</Table.Th>
              <Table.Th>Total Capital</Table.Th>
              <Table.Th>Total</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {projeto.metas?.map((m, k) => {
              return (
                <Table.Tr key={k}>
                  <Table.Td>{formatarDinheiroItl(valorTotalCusteio)}</Table.Td>
                  <Table.Td>{formatarDinheiroItl(valorTotalCapital)}</Table.Td>
                  <Table.Td>{formatarDinheiroItl(valorTotalCapital + valorTotalCusteio)}</Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
      </CardPadrao>

      <CardPadrao titulo={"Arquivos"} my={10}>
        <FileInput
          description={"Insira os arquivos e em seguida clique no botão upload"}
          multiple
          ref={inputUploadRef}
          placeholder={"Clique aqui para selecionar os arquivos"}
          onChange={onChangeUpload}
          rightSection={<BotaoUpload onClick={uploadFiles} disabled={files === ''}/>}
          rightSectionWidth={"auto"}/>

        <Divider mt={30} mb={20}/>

        <List>
          {projeto.arquivos?.map((v, k) => {
            return (
              <List.Item key={k}>
                <Anchor href="#"
                        onClick={() => baixarAnexo(v.uuid, v.nome)}>
                  {v.nome}
                </Anchor>
              </List.Item>
            )
          })}
        </List>
      </CardPadrao>
      <Grid>
        <Grid.Col span={COL_RESP_6}>
          <Atividade dados={atividadesTramitacao} titulo='Tramitações' my={10}/>
        </Grid.Col>
        <Grid.Col span={COL_RESP_6}>
          <Atividade dados={atividades} titulo='Ações' my={10}/>
        </Grid.Col>
      </Grid>
    </PaginaLogada>
  );
}
